<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div id="antrag_versicherungsbestaetigung" class="mt-3">
    <h6>Versicherungsbestätigung</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <app-versicherungsbestaetigung [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="vb" [beginndatum]="beginndatum.value ? beginndatum.value.toDate() : null" [region]="region" [antrag]="true" [motorrad]="motorrad" [expertMode]="expertMode" [ldstellen]="ldstellen"></app-versicherungsbestaetigung>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <h6>Kraftfahrzeugdaten</h6>
    <div *ngFor="let risiko of risikos.controls">
      <app-risikokfz disabled [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="risiko" [risikoKfzComponents]="risikoKfzComponents" [kaskoKfzComponents]="kaskoKfzComponents" [selected]="selected" [complete]="true" [privatperson]="privatperson" idprefix="antrag"></app-risikokfz>
    </div>
    <div id="antrag_kennzeichen" class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input">
          <app-label [control]="kennzeichen" class="input__label" for="kennzeichen">Kennzeichen:</app-label>
          <mat-form-field>
            <input matInput id="kennzeichen" [placeholder]="motorrad ? 'W-123AB' : 'W-1234AB'" [value]="kennzeichen.value | uppercase" formControlName="kennzeichen">
            <mat-error *ngIf="kennzeichen.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div id="antrag_haftpflichtversicherung" class="mt-3">
    <h6>Haftpflichtversicherung</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input">
          <label class="input__label" for="antrag_versicherungssummeVariante">Versicherungssumme:</label>
          <mat-form-field>
            <input matInput id="antrag_versicherungssummeVariante" [value]="versicherungssummeVariante?.Value" disabled>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div *ngIf="showBmStufeVerband; else _bmStufe">
      <div class="row">
        <div class="col col-xs-12 col-sm-6">
          <ng-template *ngTemplateOutlet="bmStufeVerbandTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-6">
          <ng-template *ngTemplateOutlet="bmStufeTemplate"></ng-template>
        </div>
      </div>
    </div>
    <ng-template #_bmStufe>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="bmStufeTemplate"></ng-template>
        </div>
      </div>
    </ng-template>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio" *ngIf="showHdiKfzMotorradVersicherung">
          <app-label id="antrag_hdiKfzMotorradVersicherungLabel" [control]="hdiKfzMotorradVersicherung" for="antrag_hdiKfzMotorradVersicherung">{{ motorrad ? expertMode ? 'Besteht / bestand innerhalb des letzten Jahres eine Motorrad-Versicherung?' : 'Haben / hatten Sie innerhalb des letzten Jahres eine Motorrad-Versicherung?' : expertMode ? 'Besteht / bestand innerhalb des letzten Jahres eine Kfz-Versicherung?' : 'Haben / hatten Sie innerhalb des letzten Jahres eine Kfz-Versicherung?' }}</app-label>
          <mat-radio-group id="antrag_hdiKfzMotorradVersicherung" formControlName="hdiKfzMotorradVersicherung">
            <mat-radio-button value="1">Ja, bei HDI</mat-radio-button>
            <mat-radio-button value="2">Ja, bei einer anderen Versicherung</mat-radio-button>
            <mat-radio-button value="3">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="hdiKfzMotorradVersicherung.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input" *ngIf="showHdiPolizzennummer">
          <app-label [control]="hdiPolizzennummer" class="input__label" for="hdiPolizzennummer">{{ expertMode ? 'Polizzennummer bei der HDI:' : 'Welche Polizzennummer haben / hatten Sie bei der HDI?' }}</app-label>
          <mat-form-field>
            <input matInput id="hdiPolizzennummer" formControlName="hdiPolizzennummer">
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <app-vorversicherung #_vorversicherung [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="vorversicherungGroup" [showGroup]="showHdiKfzMotorradVersicherungGroup" [isKfz]="true" [expertMode]="expertMode"></app-vorversicherung>
        <div formGroupName="hdiKfzMotorradVersicherungGroup" *ngIf="showHdiKfzMotorradVersicherungGroup">
          <div class="custom_select" *ngIf="showBmStufeVorversicherung">
            <app-label [control]="bmStufeVorversicherung" class="custom-select__label" for="antrag_bmStufeVorversicherung">{{ expertMode ? 'Bonus-Malus-Stufe bei Vorversicherung' : 'Welche Bonus-Malus-Stufe haben / hatten Sie?' }}</app-label>
            <mat-form-field>
              <mat-select id="antrag_bmStufeVorversicherung" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="bmStufeVorversicherung">
                <mat-option *ngFor="let bmstufe of bmStufenVorversicherung | keyvalue" [value]="bmstufe.key">{{ bmstufe.value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="input" *ngIf="showBmStufeNullJahre">
            <app-label [control]="bmStufeNullJahre" class="input__label" for="antrag_bmStufeNullJahre">Wie viele Jahre waren Sie in Stufe 00?</app-label>
            <mat-form-field>
              <input matInput id="antrag_bmStufeNullJahre" [maxlength]="2" formControlName="bmStufeNullJahre">
              <mat-error *ngIf="bmStufeNullJahre.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
            </mat-form-field>
          </div>
          <div class="input_radio" *ngIf="showOffeneSchaeden">
            <div class="text_info">
              <app-label [control]="offeneSchaeden" for="antrag_offeneSchaeden">{{ expertMode ? 'Gibt es Haftpflichtschäden nach dem Beobachtungszeitraum?' : 'Gibt es offene Haftpflichtschäden?' }}</app-label>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('BEOBACHTUNGSZEITRAUM') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </div>
            <mat-radio-group id="antrag_offeneSchaeden" formControlName="offeneSchaeden">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
          </div>
          <div *ngIf="showSchadenZeitpunkte">
            <app-label [control]="firstSchadenZeitpunkt" for="antrag_schaedenZeitpunkt">Wann sind diese Schäden passiert?</app-label>
            <div class="row">
              <div class="col col-xs-12 col-sm-4">
                <div class="input">
                  <mat-form-field>
                    <input matInput [matDatepicker]="firstSchadenZeitpunktPicker" placeholder="TT.MM.JJJJ" [min]="schadenZeitpunktMinDate" [max]="schadenZeitpunktMaxDate" [formControl]="firstSchadenZeitpunkt">
                    <mat-datepicker-toggle matSuffix [for]="firstSchadenZeitpunktPicker"></mat-datepicker-toggle>
                    <mat-datepicker #firstSchadenZeitpunktPicker startView="multi-year"></mat-datepicker>
                    <mat-error *ngIf="firstSchadenZeitpunkt.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
                    <mat-error *ngIf="firstSchadenZeitpunkt.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': schadenZeitpunktMinDate | date } }}</mat-error>
                    <mat-error *ngIf="firstSchadenZeitpunkt.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': schadenZeitpunktMaxDate | date } }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col col-xs-12 col-sm-4">
                <mat-form-field>
                  <input matInput [matDatepicker]="secondSchadenZeitpunktPicker" placeholder="TT.MM.JJJJ" [min]="schadenZeitpunktMinDate" [max]="schadenZeitpunktMaxDate" [formControl]="secondSchadenZeitpunkt">
                  <mat-datepicker-toggle matSuffix [for]="secondSchadenZeitpunktPicker"></mat-datepicker-toggle>
                  <mat-datepicker #secondSchadenZeitpunktPicker startView="multi-year"></mat-datepicker>
                  <mat-error *ngIf="secondSchadenZeitpunkt.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': schadenZeitpunktMinDate | date } }}</mat-error>
                  <mat-error *ngIf="secondSchadenZeitpunkt.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': schadenZeitpunktMaxDate | date } }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col col-xs-12 col-sm-4">
                <mat-form-field>
                  <input matInput [matDatepicker]="thirdSchadenZeitpunktPicker" placeholder="TT.MM.JJJJ" [min]="schadenZeitpunktMinDate" [max]="schadenZeitpunktMaxDate" [formControl]="thirdSchadenZeitpunkt">
                  <mat-datepicker-toggle matSuffix [for]="thirdSchadenZeitpunktPicker"></mat-datepicker-toggle>
                  <mat-datepicker #thirdSchadenZeitpunktPicker startView="multi-year"></mat-datepicker>
                  <mat-error *ngIf="thirdSchadenZeitpunkt.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': schadenZeitpunktMinDate | date } }}</mat-error>
                  <mat-error *ngIf="thirdSchadenZeitpunkt.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': schadenZeitpunktMaxDate | date } }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="input" *ngIf="showStornodatumVorvertrag">
            <app-label [control]="stornodatumVorvertrag" class="input-date-picker__label" for="antrag_stornodatumVorvertrag">{{ expertMode ? 'Stornodatum des Vorvertrags' : 'Falls Ihre Versicherung bereits storniert wurde, geben Sie bitte das Stornodatum an:' }}</app-label>
            <mat-form-field>
              <input matInput id="antrag_stornodatumVorvertrag" [matDatepicker]="stornodatumPicker" [max]="maxDate" placeholder="TT.MM.JJJJ" formControlName="stornodatumVorvertrag">
              <mat-datepicker-toggle matSuffix [for]="stornodatumPicker"></mat-datepicker-toggle>
              <mat-datepicker #stornodatumPicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class.mt-3]="interesseKaskoversicherung">
    <h6 *ngIf="interesseKaskoversicherung">Kaskoversicherung</h6>
    <div *ngFor="let kasko of kaskos.controls;let i=index">
      <div *ngIf="risikoKfzComponents?.toArray()[i]">
        <app-kaskokfz [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="kasko" [risikoKfzComponent]="risikoKfzComponents.toArray()[i]" [kaskoKfzComponents]="kaskoKfzComponents" [beginndatum]="beginndatum" [selected]="selected" [complete]="true" idprefix="antrag" [kaskoKfzComponent]="_kaskoKfzComponents?.toArray()[i]"></app-kaskokfz>
      </div>
    </div>
    <div id="antrag_vorherigeKaskoVersicherung" class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio" *ngIf="showKaskoVorversicherung">
          <app-label [control]="kaskoVorversicherung" for="kaskoVorversicherung">Waren Sie in den letzten 3 Jahren bei einer anderen Versicherung kaskoversichert?</app-label>
          <mat-radio-group id="kaskoVorversicherung" formControlName="kaskoVorversicherung">
            <mat-radio-button value="1">Ja, gleich wie Haftpflicht</mat-radio-button>
            <mat-radio-button value="2">Ja, abweichend von Haftpflicht</mat-radio-button>
            <mat-radio-button value="3">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <app-vorversicherung #_kaskoVorversicherung [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="kaskoVorversicherungGroup" [showGroup]="showKaskoVorversicherungGroup" [expertMode]="expertMode"></app-vorversicherung>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input" *ngIf="showKaskoStornodatumVorvertrag">
          <app-label [control]="kaskoStornodatumVorvertrag" class="input-date-picker__label" for="antrag_stornodatumVorvertrag">Falls Ihre Versicherung bereits storniert wurde, geben Sie bitte das Stornodatum an:</app-label>
          <mat-form-field>
            <input matInput id="antrag_kaskoStornodatumVorvertrag" [matDatepicker]="kaskoStornodatumPicker" [max]="maxDate" placeholder="TT.MM.JJJJ" formControlName="kaskoStornodatumVorvertrag">
            <mat-datepicker-toggle matSuffix [for]="kaskoStornodatumPicker"></mat-datepicker-toggle>
            <mat-datepicker #kaskoStornodatumPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio" *ngIf="showKaskoschaeden">
          <app-label [control]="kaskoschaeden" for="kaskoschaeden">Gab es Kaskoschäden?</app-label>
          <mat-radio-group id="kaskoschaeden" formControlName="kaskoschaeden">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input" *ngIf="showKaskoschaedenAnzahl">
          <app-label [control]="kaskoschaedenAnzahl" class="input__label" [for]="kaskoschaedenAnzahl">Wie viele Kaskoschäden hatten Sie?</app-label>
          <mat-form-field>
            <input matInput [id]="kaskoschaedenAnzahl" formControlName="kaskoschaedenAnzahl">
            <mat-error *ngIf="kaskoschaedenAnzahl.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="kaskoschaedenAnzahl.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="insassenVariante">
    <h6>Insassenunfall</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input">
          <label class="input__label" for="antrag_insassenVariante">Insassenunfallversicherung:</label>
          <mat-form-field>
            <input matInput id="antrag_insassenVariante" [value]="insassenVariante.Value" disabled>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <h6>Errechnung der Prämie</h6>
    <div class="row">
      <div class="col col-xs-12 col-sm-12" *ngFor="let sparte of kfzResult.Sparten;let i=index">
        <div class="input">
          <label class="input__label" [for]="'sparte_' + i">{{ sparte.SparteBezeichnung }}:</label>
          <mat-form-field>
            <input matInput [id]="'sparte_' + i" [value]="sparte.BruttoPraemie | customCurrency" disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input">
          <label class="input__label" for="motorsteuer">Motorbezogene Versicherungssteuer:</label>
          <mat-form-field>
            <input matInput id="motorsteuer" [value]="kfzResult.MotorSteuer | customCurrency" disabled>
          </mat-form-field>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div class="input">
          <label class="input__label" for="gesamt">Gesamt:</label>
          <mat-form-field>
            <input matInput id="gesamt" [value]="kfzResult.Gesamt | customCurrency" disabled>
          </mat-form-field>
        </div>
      </div>
    </div>
    <ng-template #bmStufeVerbandTemplate>
      <div class="input" *ngIf="showBmStufeVerband">
        <label class="input__label" for="antrag_bmStufeVerband">Bonus-Malus-Stufe Verband:</label>
        <mat-form-field>
          <input matInput id="antrag_bmStufeVerband" [value]="bmStufeVerband?.Value" disabled>
        </mat-form-field>
      </div>
    </ng-template>
    <ng-template #bmStufeTemplate>
      <div class="input" *ngIf="showBmStufe">
        <label class="input__label" for="antrag_bmStufe">{{ (expertMode ? '' : 'Beantragte ') + 'Bonus-Malus-Stufe' + (expertMode ? ' Intern' : '') + ':' }}</label>
        <mat-form-field>
          <input matInput id="antrag_bmStufe" [value]="bmStufe?.Value" disabled>
        </mat-form-field>
      </div>
    </ng-template>
  </div>
</form>
